import React from 'react';
import TextEditor from './TextEditor';

const SECTION_COLORS = {
  leadin:     '#6d28d9',
  reading:    '#1e40af',
  vocabulary: '#065f46',
  grammar:    '#92400e',
  speaking:   '#0c4a6e',
  listening:  '#134e4a',
  homework:   '#1f2937',
};

const LessonContainer = ({
  id,
  setMainEditor,
  setActiveEditorId,
  addEditorToMap,
  initialContent,
  onContentChange,
  isStudent = false,
  lessonMode = 'edit',
  liveContent = null,
  isStudentLocked = false,
  sectionType,
  sectionTitle,
  sectionColor,
  sectionMinutes,
}) => {
  const hasSectionHeader = !!(sectionType && sectionTitle);
  const headerColor = SECTION_COLORS[sectionType] || sectionColor || '#1f2937';

  return (
    <div
      className="lesson-container"
      style={{
        minHeight: hasSectionHeader ? 0 : '60vh',
        background: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.05)',
        marginTop: '0',
        marginBottom: '28px',
        position: 'relative',
      }}
    >
      {hasSectionHeader && (
        <div style={{
          background: headerColor,
          borderRadius: '16px 16px 0 0',
          padding: '13px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}>
          <span style={{
            color: 'rgba(255,255,255,0.95)',
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
          }}>
            {sectionTitle}
          </span>
          {sectionMinutes > 0 && (
            <span style={{
              color: 'rgba(255,255,255,0.45)',
              fontSize: 11,
              fontWeight: 400,
              letterSpacing: '0.03em',
            }}>
              · {sectionMinutes} min
            </span>
          )}
        </div>
      )}
      <div style={{ padding: '45px 18px' }}>
        <TextEditor
          id={id}
          setMainEditor={setMainEditor}
          setActiveEditor={setActiveEditorId}
          addEditorToMap={addEditorToMap}
          initialContent={initialContent}
          onContentChange={onContentChange}
          isStudent={isStudent}
          lessonMode={lessonMode}
          liveContent={liveContent}
          isStudentLocked={isStudentLocked}
        />
      </div>
    </div>
  );
};

export default LessonContainer;
